import React, { Component } from 'react';
import { MODAL_SHARE_AS_HTML } from '../../util/enums/EnumModals';
import { CopyBox } from '../CopyBox';

class ModalShareAsHtml extends Component {
  static modalType() {
    return MODAL_SHARE_AS_HTML;
  }

  static reducer(modals) {
    return modals.shareAsHtmlModal;
  }

  static title() {
    return (
      <span>
        <span
          className="glyphicon glyphicon-link margin-right-10"
          aria-hidden="true"
        />
        Share with PIN code
      </span>
    );
  }

  static includeSaveButton() {
    return false;
  }

  render() {
    const { state } = this.props;

    const { url } = state;
    const hasPin = !!state.shareablePassword;
    return (
      <div className="margin-10">
        <div className="margin-left-20 margin-right-20">
          <label>
            Copy and share the following link {hasPin ? 'and PIN code' : ''}:
          </label>
          <br />
          <br />
          <CopyBox value={url}>
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => window.open(url, '_blank')}
            >
              Open
            </button>
          </CopyBox>
          <br />
          {!hasPin ? null : (
            <h4>
              <label className="margin-right-10">PIN: </label>
              {state.shareablePassword}
            </h4>
          )}
          <br />
          <small className="pull-right faint">
            Anyone with the link {hasPin ? 'and pin code' : ''} will be able to
            see these results.
          </small>
        </div>
      </div>
    );
  }
}

export default ModalShareAsHtml;
